import { AttributeValue } from "../../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { HTMLEditor } from "../../../../library-js/dom-tools/HTMLEditor";
import { RegExpUtility } from "../../../../library-js/text/RegExpUtility";
import { GodotDocsVersion } from "../../../js/godot-docs/GodotDocsVersion";
import { Rokojori } from "../../../js/Rokojori";
import { GodotNode } from "./GodotNode";

export class GodotSceneHierarchyPath
{
  static readonly type  = new ElementType( "godot-editor-hierarchy-path-content" );
  static readonly entry = new ElementType( "godot-editor-hierarchy-path-entry" ); 
  static readonly separator = new ElementType( "godot-editor-path-separator" );

  static applyOnDocument()
  {
    console.log( "GodotSceneHierarchyPath:" );
    GodotSceneHierarchyPath.type.forAllInDoc( e => GodotSceneHierarchyPath.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {    
    GodotDocsVersion.toNewest();
    
    let splits = e.textContent.split( "▸" );

    console.log( "splits:", splits );
    e.innerHTML = "";

    let isFirst = true;

    splits.forEach(
      ( s )=>
      {
        if ( isFirst )
        {
          isFirst = false;
        }
        else
        {
          let separatorEntry = GodotSceneHierarchyPath.separator.create( " ▸ " ); 
          e.appendChild( separatorEntry );
        }

        let gn = GodotNode.create( s.trim() );        
        let icon = gn._iconElement;
        let label = gn._labelElement;

        console.log( icon, label, gn );
        let entry = GodotSceneHierarchyPath.entry.create( [ icon, label ] );

        

        e.appendChild( entry );
        

      }
    );
    

  }
}